import { space } from "./Core"

// Object to store pre-calculated pixel-to-rem conversions
export const pixelToRemMap = {
  12: '0.75rem',
  14: '0.875rem',
  16: '1rem',
  18: '1.125rem',
  20: '1.25rem',
  22: '1.375rem',
  24: '1.5rem',
  26: '1.625rem',
  28: '1.75rem',
  29: '1.8125rem',
  30: '1.875rem',
  32: '2rem',
  36: '2.25rem',
  40: '2.5rem',
  44: '2.75rem',
  47: '2.9375rem',
  48: '3rem',
  52: '3.25rem',
  58: '3.625rem',
  57: '3.5625rem',
  64: '4rem',
  85: '5.3125rem',
  114: '7.125rem',
  140: '8.75rem',
  81: '5.0625rem',
  280: '17.5rem',
  326: '20.375rem',
  328: '20.5rem',
  357: '22.3125rem',
  360: '22.5rem',
  365: '22.8125rem',
  390: '24.375rem',
  400: '25rem',
  450: '28.125rem',
  700: '43.75rem',
  768: '48rem',
  1128: '70.5rem',
  1024: '64rem',
  1920: '120rem'
}

const maxWidth1024 = `(max-width: ${pixelToRemMap[1024]})`

export const fonts = {
  medium: '"Apax Medium", Helvetica, sans-serif',
  regular: '"Apax Regular", Helvetica, sans-serif',
  bold: '"Apax Bold", Helvetica, sans-serif',
  light: '"Apax Light", Helvetica, sans-serif'
}

export const typography = {
  fontFamily: [fonts.regular, fonts.medium, fonts.bold, fonts.light].join(","),
  displayLarge: {
    fontSize: pixelToRemMap[57],
    lineHeight: pixelToRemMap[64],
    fontWeight: 700,
    fontFamily: fonts.bold,
    marginBottom: `${space.spacing[12]}px`,
    [`@media ${maxWidth1024}`]: {
      fontSize: pixelToRemMap[36],
      lineHeight: pixelToRemMap[44]
    }
  },
  displayMedium: {
    fontSize: pixelToRemMap[47],
    lineHeight: pixelToRemMap[52],
    fontWeight: 700,
    fontFamily: fonts.bold,
    marginBottom: `${space.spacing[12]}px`
  },
  displaySmall: {
    fontSize: pixelToRemMap[36],
    lineHeight: pixelToRemMap[44],
    fontWeight: 700,
    fontFamily: fonts.bold,
    marginBottom: `${space.spacing[12]}px`
  },
  headlineLarge: {
    fontSize: pixelToRemMap[32],
    lineHeight: pixelToRemMap[40],
    fontWeight: 700,
    fontFamily: fonts.bold,
    marginBottom: `${space.spacing[10]}px`
  },
  headlineMedium: {
    fontSize: pixelToRemMap[28],
    lineHeight: pixelToRemMap[36],
    fontWeight: 700,
    fontFamily: fonts.bold,
    marginBottom: `${space.spacing[7]}px`,
    paddingLeft: '12px',
    paddingRight: '12px'
  },
  headlineSmall: {
    fontSize: pixelToRemMap[24],
    lineHeight: pixelToRemMap[32],
    fontWeight: 700,
    fontFamily: fonts.bold,
    marginBottom: `${space.spacing[2]}px`
  },
  headlineXS: {
    fontSize: pixelToRemMap[22],
    lineHeight: pixelToRemMap[28],
    fontWeight: 700,
    fontFamily: fonts.bold,
    marginBottom: `${space.spacing[2]}px`
  },
  titleLarge: {
    fontSize: pixelToRemMap[22],
    lineHeight: pixelToRemMap[28],
    fontWeight: 400,
    marginBottom: `${space.spacing[4]}px`,
    fontFamily: fonts.regular
  },
  titleMedium: {
    fontSize: pixelToRemMap[18],
    lineHeight: pixelToRemMap[24],
    fontWeight: 700,
    fontFamily: fonts.bold,
    marginBottom: `${space.spacing[4]}px`,
    letterSpacing: "0.1px"
  },
  titleSmall: {
    fontSize: pixelToRemMap[16],
    lineHeight: pixelToRemMap[20],
    fontWeight: 700,
    fontFamily: fonts.medium,
    marginBottom: `${space.spacing[4]}px`,
    letterSpacing: "0.1px"
  },
  labelXLarge: {
    fontSize: pixelToRemMap[18],
    lineHeight: pixelToRemMap[26],
    fontWeight: 400,
    fontFamily: fonts.regular,
    letterSpacing: "0.1px"
  },
  labelLarge: {
    fontSize: pixelToRemMap[14],
    lineHeight: pixelToRemMap[20],
    fontWeight: 500,
    fontFamily: fonts.medium,
    letterSpacing: "0.1px"
  },
  labelMedium: {
    fontSize: pixelToRemMap[12],
    lineHeight: pixelToRemMap[16],
    fontWeight: 600,
    fontFamily: fonts.bold,
    letterSpacing: "0.5px"
  },
  labelSmall: {
    fontSize: pixelToRemMap[12],
    lineHeight: pixelToRemMap[16],
    fontWeight: 500,
    fontFamily: fonts.medium,
    letterSpacing: "0.5px"
  },
  bodyLarge: {
    fontSize: pixelToRemMap[16],
    lineHeight: pixelToRemMap[24],
    fontWeight: 400,
    fontFamily: fonts.regular,
    letterSpacing: "0.5px"
  },
  bodyMedium: {
    fontSize: pixelToRemMap[14],
    lineHeight: pixelToRemMap[20],
    fontWeight: 400,
    fontFamily: fonts.regular,
    letterSpacing: "0.25px"
  },
  bodySmall: {
    fontSize: pixelToRemMap[12],
    lineHeight: pixelToRemMap[16],
    fontWeight: 400,
    fontFamily: fonts.regular,
    letterSpacing: "0.4px"
  }
}
